import { DataTypes } from "../types";

export const isBasicInvoiceOption = (dataTypes: string[]) =>
  dataTypes.length === 1 && dataTypes[0] === DataTypes.Invoices;

export const isDetailedInvoiceOption = (dataTypes: string[]) => {
  if (dataTypes.length !== 2) return false;

  const [a, b] = dataTypes;
  return (
    (a === DataTypes.Invoices && b === DataTypes.InvoiceItems) ||
    (a === DataTypes.InvoiceItems && b === DataTypes.Invoices)
  );
};

export const isAnyInvoiceOption = (dataTypes: string[]) =>
  dataTypes.includes(DataTypes.Invoices) ||
  dataTypes.includes(DataTypes.InvoiceItems);